// @ts-ignore
import { useQuery } from 'react-query';
import api from '../../api/client';
import { dicomStudyKeys } from './dicomStudy.keys';
var syncDicomStudies = function (patientId) {
    var url = "/api/dicomstudies/syncStudies?patientId=".concat(patientId);
    return api.post(url).then(function (response) {
        var studies = response.data;
        return studies;
    });
};
export var useSyncDicomStudiesByPatientId = function (_a) {
    var patientId = _a.patientId, _b = _a.refetchIntervalMs, refetchIntervalMs = _b === void 0 ? 7000 : _b;
    return useQuery(dicomStudyKeys.list("?patientId=".concat(patientId)), function () { return syncDicomStudies(patientId); }, {
        enabled: !!patientId,
        // @ts-ignore
        refetchInterval: refetchIntervalMs,
        refetchIntervalInBackground: true,
    });
};
